import getCurrentRoute from '../../helpers/get-current-route';
import { whoopsMessage } from '../../i18n/translations';
import { getIsVerboseOn } from '../selectors';
import getStore from '../index';
import axios from 'axios';
import { lock, clearBodyLocks } from 'tua-body-scroll-lock';
import { trackInteraction, Screen } from '@ifit/put-a-ring-on-it';
import { LibraryInteractions } from '../../helpers/analytics';

export const actionTypes = {
  SET_ERROR: 'ERROR::SET',
  RESET_ERROR: 'ERROR::RESET',
};

export function setError(error) {
  window.scrollTo(0, 0);
  const targetElement = document.querySelector('.whoops');
  lock(targetElement);
  return {
    type: actionTypes.SET_ERROR,
    error: error.message || error,
    page: getCurrentRoute(),
  };
}

export function handleError(dispatch, error) {
  const verboseMode = getIsVerboseOn(getStore().getState()) || false;
  const displayError = verboseMode ? error : whoopsMessage();

  if (axios.isCancel(error)) return;

  if (window.NODE_ENV === 'production') {
    trackInteraction({
      screen: Screen.Library,
      interactionName: LibraryInteractions.WhoopsError,
      payload: {
        error: error.message ?? error,
        route: getCurrentRoute(),
        screen: Screen.Library,
      },
    });
    dispatch(setError(displayError));
  } else {
    dispatch(setError(error));
  }
}

export function resetError() {
  clearBodyLocks();
  return { type: actionTypes.RESET_ERROR };
}

export function generateFullScreenErrorThunk(error) {
  let displayError;

  try {
    displayError = JSON.parse(error);
  } catch (e) {
    displayError = error;
  }

  return async dispatch => {
    handleError(dispatch, `All sections failed to load. ${displayError}`);
  };
}

export function showFullScreenError(error) {
  return generateFullScreenErrorThunk(error);
}
